import { Box, Paper, Typography } from "@mui/material";
import React from "react";

export default function CeoStatement({ statementData }) {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "#e6efff",
        borderLeft: "5px solid #1e3a8a",
        borderRadius: 2,
        p: 2,
        mt: 1,
      }}
    >
      {statementData?.map((item, index) => (
        <Typography
          key={index}
          fontSize={15}
          color="#374151"
          lineHeight={1.6}
          mb={1}
        >
          {item.content}
        </Typography>
      ))}
      <Typography fontWeight={600} mt={1}>
        – Ankita Goyal, Founder &amp; MD
      </Typography>
    </Paper>
  );
}
